// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ciHB","importantInfo":"styles_importantInfo__3mBj4"};